import { inject } from "vue";
import { cartTotalsKeys } from "./useCartTotals";

export function useCartTotalsStore() {
  const cartTotals = inject(cartTotalsKeys);

  if (!cartTotals) {
    throw new Error("useCartTotalsStore must be used within a CartTotalsProvider");
  }

  return cartTotals;
}